import { isDevEnvironment } from "@utils/utils"

export const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FB_PIXEL_ID!

export const fbPageView = () => {
  if (isDevEnvironment) return
  window.fbq("track", "PageView")
}

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const fbEvent = (name: string, options: object) => {
  if (isDevEnvironment) return
  window.fbq("track", name, options)
}
